/**
 * 개발 도구 — artisan 커맨드 목록 (/adm/dev/commands)
 * ($j.Pages.Admin.DevCommands / body data-page-name="DevCommands")
 *
 * 등록된 커맨드를 서버에서 읽어 그룹 색인·카드로 보여준다. 실행 버튼은 없다 — 복사해서 서버에서 친다.
 */
let DATA = null;
let activeGroup = '';   // '' 면 전체

export default class DevCommands {
    initialize() {
        load();

        // 글자 검색은 전체를 뒤진다 — 그룹을 골라 둔 채로 치면 "왜 안 나오지"가 된다
        $('#filter').on('input', function () { selectGroup('', true); });

        $(document).on('click', '.acm-doc-toggle', onToggleDoc);
        $(document).on('click', '.acm-copy', onClickCopy);
        $(document).on('click', '#vendorHead', onToggleVendor);
        $(document).on('click', '.acm-index a', function (e) {
            e.preventDefault();
            const g = String($(this).data('group') || '');
            selectGroup(activeGroup === g ? '' : g);   // 같은 걸 다시 누르면 전체로 돌아온다
        });
    }
}

/** 그룹 고르기 — 스크롤 대신 걸러낸다 */
function selectGroup(g, keepScroll) {
    activeGroup = g;

    $('.acm-index a').removeClass('is-active')
                     .filter(`[data-group="${cssEsc(g)}"]`).addClass('is-active');
    applyFilter();

    // 고른 그룹이 바로 눈앞에 오게 한 번만 되돌린다. 부드럽게 굴리지 않는다 —
    // 스르륵 흘러가는 그 시간이 원래 불편했던 것이다
    if (!keepScroll) document.querySelector('.acm-bar').scrollIntoView({ block: 'start' });
}

function load() {
    $.post('/adm/ajax/dev/commands/list', {}, function (res) {
        if (!res.result) { $('#list').html('<span class="acm-muted">불러오지 못했습니다.</span>'); return; }

        DATA = res;
        $('#summary').text(`우리 커맨드 ${res.summary.own}개 · 프레임워크·패키지 ${res.summary.vendor}개`);
        $('#index').html(
            `<a class="is-active" data-group=""><b>전체</b><span>${res.summary.own}</span></a>`
            + res.groups.map(g =>
                `<a data-group="${esc(g.name)}"><b>${esc(g.name)}</b><span>${g.count}</span></a>`).join(''));

        $('#list').html(renderGroups(res.own, res.groups));
        $('#vendorCount').text(`(${res.vendor.length})`);
        $('#vendorList').html(res.vendor.map(c =>
            `<div class="acm-vendor-row"><code>${esc(c.name)}</code><span>${esc(c.description)}</span></div>`).join(''));

        applyFilter();   // 벤더 묶음 노출까지 여기서 한 번에 정한다
    });
}

function renderGroups(own, groups) {
    return groups.map(function (g) {
        const cards = own.filter(c => c.group === g.name).map(cardHtml).join('');
        return `<div class="acm-group" data-group="${esc(g.name)}">
                    <h2><code>${esc(g.name)}</code> <span>${g.count}개</span></h2>
                    ${cards}
                </div>`;
    }).join('');
}

function cardHtml(c) {
    // 걸러내기가 화면에 없는 값(옵션 설명·주석)까지 보게 해 둔다 — 이름만 봐서는 못 찾는 일이 잦다
    const hay = [c.name, c.description, c.doc,
                 c.options.map(o => o.name + ' ' + o.description).join(' '),
                 c.arguments.map(a => a.name + ' ' + a.description).join(' ')].join(' ').toLowerCase();

    const usage = c.usage.length
        ? `<pre class="acm-usage">${c.usage.map(esc).join('\n')}</pre>`
        : `<pre class="acm-usage">php artisan ${esc(c.name)}${synopsis(c)}</pre>`;

    return `<div class="acm-card" data-search="${esc(hay)}">
                <div class="acm-head">
                    <span class="acm-name">${esc(c.name)}</span>
                    <button type="button" class="acm-copy" data-cmd="${esc('php artisan ' + c.name)}"
                            title="php artisan ${esc(c.name)} 복사"><i class="far fa-copy"></i></button>
                    <span class="acm-desc">${esc(c.description)}</span>
                    <span class="acm-src">${esc(c.source)}</span>
                </div>
                ${usage}
                ${defsHtml(c)}
                ${c.doc ? `<span class="acm-doc-toggle">머리 주석 펼치기 ▾</span>
                           <div class="acm-doc">${esc(c.doc)}</div>` : ''}
            </div>`;
}

/** 사용 예가 주석에 없을 때 쓰는 한 줄 — 인자·옵션으로 형태만 보여준다 */
function synopsis(c) {
    const args = c.arguments.map(a => a.required ? ` {${a.name}}` : ` [{${a.name}}]`).join('');
    const opts = c.options.map(o => ` [--${o.name}${o.value ? '=' : ''}]`).join('');
    return args + opts;
}

function defsHtml(c) {
    let html = '';

    if (c.arguments.length) {
        html += '<div class="acm-label">인자</div><table>'
             + '<tr><th>이름</th><th>필수</th><th>기본값</th><th>설명</th></tr>'
             + c.arguments.map(a => `<tr>
                    <td class="k">${esc(a.name)}${a.array ? '…' : ''}</td>
                    <td>${a.required ? '<span class="acm-req">필수</span>' : '-'}</td>
                    <td class="k">${esc(a.default) || '-'}</td>
                    <td>${esc(a.description) || '-'}</td></tr>`).join('')
             + '</table>';
    }

    if (c.options.length) {
        html += '<div class="acm-label">옵션</div><table>'
             + '<tr><th>이름</th><th>값</th><th>기본값</th><th>설명</th></tr>'
             + c.options.map(o => `<tr>
                    <td class="k">--${esc(o.name)}${o.shortcut ? ' (-' + esc(o.shortcut) + ')' : ''}</td>
                    <td>${o.value ? '받음' : '플래그'}</td>
                    <td class="k">${esc(o.default) || '-'}</td>
                    <td>${esc(o.description) || '-'}</td></tr>`).join('')
             + '</table>';
    }

    return html ? `<div class="acm-defs">${html}</div>` : '';
}

/* ── 걸러내기 ────────────────────────────────── */

/**
 * 걸러내기 — 글자(전체 검색)와 그룹(좌측 인덱스) 두 축이 같이 작용한다.
 *
 * 맞은 개수는 DOM 에 묻지 않고 **세면서 직접 센다.** `:visible` 은 숨은 조상 밑의 자식을
 * 언제나 false 로 보므로, 한 번 접힌 그룹은 카드를 다시 켜도 영영 안 펴진다.
 */
function applyFilter() {
    const q = $('#filter').val().trim().toLowerCase();

    $('.acm-group').each(function () {
        const g = String($(this).data('group'));
        let hit = 0;

        $(this).find('.acm-card').each(function () {
            const ok = !q || ($(this).data('search') || '').indexOf(q) >= 0;
            $(this).toggle(ok);
            if (ok) hit++;
        });

        // 인덱스를 흐리게 하는 건 **글자 검색 결과만** 말한다. 그룹 선택은 is-active 가 말한다
        $(`.acm-index a[data-group="${cssEsc(g)}"]`).toggleClass('is-off', hit === 0);

        // 남은 게 없는 그룹은 제목만 남기지 않는다 — 빈 제목이 줄줄이 서면 훑기가 더 어렵다
        $(this).toggle(hit > 0 && (!activeGroup || activeGroup === g));
    });

    // 벤더 묶음은 어느 그룹에도 안 속한다. 그룹을 고른 동안엔 통째로 빠진다
    let vendorHit = 0;
    $('.acm-vendor-row').each(function () {
        const ok = !q || $(this).text().toLowerCase().indexOf(q) >= 0;
        $(this).toggle(ok);
        if (ok) vendorHit++;
    });

    $('#vendorBox').toggle(!activeGroup && vendorHit > 0);
    if (q && vendorHit && !activeGroup) openVendor();
}

/* ── 조작 ────────────────────────────────────── */

function onToggleDoc() {
    const $doc = $(this).next('.acm-doc');
    const open = $doc.is(':visible');
    $doc.slideToggle(120);
    $(this).text(open ? '머리 주석 펼치기 ▾' : '머리 주석 접기 ▴');
}

function onClickCopy() {
    const $b = $(this);
    navigator.clipboard.writeText($b.data('cmd')).then(function () {
        $b.html('<i class="fas fa-check"></i>');
        setTimeout(() => $b.html('<i class="far fa-copy"></i>'), 1200);
    });
}

function onToggleVendor() {
    if ($('#vendorList').is(':visible')) {
        $('#vendorList').slideUp(120);
        $('#vendorHead i').attr('class', 'fas fa-caret-right');
    } else {
        openVendor();
    }
}

function openVendor() {
    $('#vendorList').slideDown(120);
    $('#vendorHead i').attr('class', 'fas fa-caret-down');
}

function esc(s) {
    return String(s === null || s === undefined ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function cssEsc(s) { return String(s).replace(/(["\\])/g, '\\$1'); }
